import { SWISS_FORMAT_LOCALE } from './constants';

export function formatCurrency(amount: number, currency: string): string {
  return new Intl.NumberFormat(SWISS_FORMAT_LOCALE, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(amount);
}

/** Grouped `de-CH` number, no currency symbol. Negative sign is added by the
 * locale. */
export function formatSwissAmount(amount: number): string {
  return amount.toLocaleString(SWISS_FORMAT_LOCALE, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** "CHF 1'234.56" — plain-space prefix (`formatCurrency` would insert a
 * non-breaking space between code and digits). */
export function formatCHF(amount: number): string {
  return `CHF ${formatSwissAmount(amount)}`;
}
